module.exports = __webpack_public_path__ + "img/order-ico5.8ad6f9d8.svg";